import React, { useState } from 'react';
import { ensureCurrentUser, ensureUser } from '../../../../util/data';
import { trimDisplayNameLastWord } from '../../../../util/text';
import { AvatarMedium } from '../../../../components';
import ExternalHorseModal from '../../components/ExternalHorseModal';
import css from './SectionContact.css';
import ContactUserSection from './ContactUserSection';
import { useIntl } from 'react-intl';
import { priceData } from '../../../../util/currency';
import { getUserCountrySpecInfo } from '../../../../util/location';
import { IconCheckCircleM } from '../../../../icons';

const SectionContact = ({
    isAnonymousListing,
    currentListing,
    listingAuthor,
    isOwnListing,
    riderListing,
    loading,
}) => {
    const intl = useIntl();
    const [externalListingModalOpen, setExternalListingModalOpen] = useState();

    const { price = null } = currentListing?.attributes || {};
    const { formattedPrice } = priceData(price, intl);
    const { country } = listingAuthor?.attributes?.profile?.publicData || {};
    const { currency: authorCurrency } = getUserCountrySpecInfo(country) || {};

    const defaultPrice = `0 ${authorCurrency || 'CHF'}`;

    const { package2, package3, externalSourceLink, externalSourceName, externalListing } =
        currentListing.attributes.publicData || {};

    const multiPackage =
        (package2 && package2.active && package2.price) ||
        (package3 && package3.active && package3.price);

    const userIsCurrentUser = listingAuthor && listingAuthor.type === 'currentUser';

    const ensuredAuthor = userIsCurrentUser
        ? ensureCurrentUser(listingAuthor)
        : ensureUser(listingAuthor);

    const { displayName } = ensuredAuthor?.attributes?.profile || {};

    const joiningDate = listingAuthor
        ? new Date(listingAuthor.attributes?.createdAt).getFullYear()
        : 'N/A';

    const authorDisplayName = trimDisplayNameLastWord(displayName);

    if (!currentListing?.id?.uuid) {
        return null;
    }

    return (
        <>
            {externalListing ? (
                <ExternalHorseModal
                    onCloseModal={() => setExternalListingModalOpen(false)}
                    isModalOpen={externalListingModalOpen}
                    externalSourceLink={externalSourceLink}
                    externalSourceName={externalSourceName}
                />
            ) : null}

            <div className={css.root}>
                <div className={css.priceContainer}>
                    <span className={css.price}>
                        {multiPackage ? <span>Ab </span> : null}
                        {formattedPrice || defaultPrice}
                    </span>
                    <div className={css.priceBottomText}>Monatliche Kosten</div>
                </div>

                <div className={css.profileContainer}>
                    <div className={css.avatarWrapper}>
                        <AvatarMedium
                            user={listingAuthor}
                            disableProfileLink={isAnonymousListing}
                            className={css.avatar}
                        />
                    </div>
                    <div>
                        <span className={css.userName}>{authorDisplayName}</span>
                        <p className={css.userBottomText}>
                            <IconCheckCircleM />
                            <span>Mitglied seit {joiningDate}</span>
                        </p>
                    </div>
                </div>

                <ContactUserSection
                    loading={loading}
                    riderListing={riderListing}
                    isOwnListing={isOwnListing}
                    listingAuthor={listingAuthor}
                    currentListing={currentListing}
                    userIsCurrentUser={userIsCurrentUser}
                    isAnonymousListing={isAnonymousListing}
                    setExternalListingModalOpen={setExternalListingModalOpen}
                />
            </div>
        </>
    );
};

export default SectionContact;
